<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VMm9Hd/tc-custom/9781504086851.jpg?1694225378356" alt="This image is the cover for the book Good Child"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Good Child
      </h1>
      <p class="bookDescription body article font2">
        <b>The murder of a teenage boy reveals fractured relationships, in this twist-filled new psychological thriller by the author of <i>Penance</i>.</b><br/><br/> Single mother Annie has spent ten years raising her daughter, Jessica, on her own—and now Jessica’s on the verge of adulthood. Annie’s just relieved that she’s found a sweetheart in Ryan, the son of her close friends, a respectable boy they’ve both known for years.<br/><br/> But the fairy-tale romance between the two teenagers is not to be. As if the traumatic loss of her father wasn’t bad enough, Jessica has now lost her boyfriend—to a killer. Jessica is distraught. Ryan’s parents are in shock. And the heartbreak only grows as evidence begins to emerge that Ryan may not have been the upstanding young man that they thought.<br/><br/> In the face of an unsolved murder and shocking revelations, those left behind struggle to move on and relationships start to fall apart under the strain. What was real? What was an illusion? And are some truths just too difficult to face?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charlotte Barnes
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13eb580e